module.exports = __webpack_public_path__ + "media/images/flags/64/Kazakhstan-0fa42bb194a402cd56aebc58b9f497d3.png";